const noticeStatus = [
    { text: 'new', value: 'new' },
    { text: 'approved', value: 'approved' },
    { text: 'declined', value: 'declined' }
];

export {
    noticeStatus
}